import { RoleAccess } from "../../hooks/auth/types";
import { Role } from "../../models/Shared/Role";

export const SCHOOL_CANDIDATE_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.CountyAdministrator,
    Role.CountyLeader,
    Role.InstitutionAdministrator,
    Role.InstitutionPrincipal,
    Role.Founder,
  ],
};

export const INSTITUTION_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.CountyAdministrator,
    Role.CountyLeader,
    Role.InstitutionAdministrator,
    Role.InstitutionPrincipal,
    Role.Founder,
  ],
};

export const ADMINISTRATION_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.CountyAdministrator,
    Role.CountyLeader,
    Role.InstitutionAdministrator,
    Role.InstitutionPrincipal,
  ],
};

export const COMMITTEE_ACCESS: RoleAccess = {
  whitelist: [
    Role.CAS,
    Role.Helpdesk,
    Role.CountyAdministrator,
    Role.CountyLeader,
    Role.InstitutionPrincipal,
    Role.InstitutionAdministrator,
  ],
};

export const REQUEST_ADMIN_BLACKLIST: RoleAccess = {
  blacklist: [
    Role.MinistryAdministrator,
    Role.CountyCommittee,
    Role.RegionalCommittee,
  ],
};
